import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const TermsOfServiceLegacyInsurance: React.FC = () => {
  return (
    <Container className="my-5">
      <Row>
        <Col md={{ span: 10, offset: 1 }}>
          <h1 className="mb-4">Terms of Service</h1>

          <p>Effective Date: July 23, 2025</p>

          <h4>1. Introduction</h4>
          <p>
            Welcome to Legacy Insurance Network ("Company", "we", "our", or "us"). By using our website and services, you agree to be bound by these Terms of Service ("Terms").
            If you do not agree to these Terms, please do not use our site or services.
          </p>

          <h4>2. Services</h4>
          <p>
            Legacy Insurance Network provides access to insurance-related content, services, referrals, and tools. We are not an insurance carrier. We may connect users with licensed insurance professionals.
          </p>

          <h4>3. Eligibility</h4>
          <p>
            You must be at least 18 years old to use our website. By using our services, you represent and warrant that you are of legal age and capable of entering into a binding agreement.
          </p>

          <h4>4. Use of the Site</h4>
          <ul>
            <li>You agree not to misuse the website or its contents.</li>
            <li>You may not attempt to access data not intended for you.</li>
            <li>You agree not to use the site for any unlawful or unauthorized purpose.</li>
          </ul>

          <h4>5. Intellectual Property</h4>
          <p>
            All content, trademarks, logos, and materials on this site are the property of Legacy Insurance Network or its licensors. You may not reproduce, distribute, or use content without written permission.
          </p>

          <h4>6. Third-Party Links</h4>
          <p>
            Our site may contain links to third-party websites. We do not endorse or control these sites and are not responsible for their content or privacy practices.
          </p>

          <h4>7. Disclaimers</h4>
          <p>
            Our website is provided "as is" and "as available". We make no warranties, expressed or implied, including merchantability or fitness for a particular purpose.
          </p>

          <h4>8. Limitation of Liability</h4>
          <p>
            Legacy Insurance Network shall not be liable for any indirect, incidental, or consequential damages arising out of your use of our website or services.
          </p>

          <h4>9. Indemnification</h4>
          <p>
            You agree to indemnify and hold harmless Legacy Insurance Network from any claims, damages, or legal fees arising from your use of the site or violation of these Terms.
          </p>

          <h4>10. Changes to Terms</h4>
          <p>
            We may update these Terms at any time. Continued use of the site after changes constitutes acceptance of the new Terms.
          </p>

          <h4>11. Governing Law</h4>
          <p>
            These Terms are governed by and construed in accordance with the laws of the State of Colorado, without regard to conflict of law principles.
          </p>

          <h4>12. Contact</h4>
          <p>
            For questions about these Terms, please contact us at: <br />
            <strong>Email:</strong> tos.legal@LegacyInsuranceNetwork.com
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsOfServiceLegacyInsurance;
